import { render, staticRenderFns } from "./CompanyFormModal.vue?vue&type=template&id=340dd153"
import script from "./CompanyFormModal.vue?vue&type=script&lang=js"
export * from "./CompanyFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports